import {
  DETAIL_USER_EMAIL_CHANGE,
  DETAIL_USER_FIRST_NAME_CHANGE,
  DETAIL_USER_GET,
  DETAIL_USER_GROUP_ADD,
  DETAIL_USER_GROUP_REMOVE,
  DETAIL_USER_LAST_NAME_CHANGE,
  DETAIL_USER_PASSWORD_RESET,
} from './actionTypes'

/**
 * Patch request to API to change a specific user's email.
 * @param {Number} id
 * @param {Number} email
 */
export const emailChange = (id, email) => ({
  meta: {
    data: { id, email },
    errorMessage: `Error updating user information. Please try again.`,
    method: 'patch',
    successMessage: `Updated user information.`,
    url: '/api/v1/users/changeEmail',
  },
  type: DETAIL_USER_EMAIL_CHANGE,
})

/**
 * Patch request to API to change a specific user's first name.
 * @param {Number} id
 * @param {Number} firstName
 */
export const firstNameChange = (id, firstName) => ({
  meta: {
    data: { id, firstName },
    errorMessage: `Error updating user information. Please try again.`,
    successMessage: `Updated user information.`,
    method: 'patch',
    url: '/api/v1/users/changeFirstName',
  },
  type: DETAIL_USER_FIRST_NAME_CHANGE,
})

/**
 * Patch request to API to add a group to a specific user.
 * @param {Number} id
 * @param {Number} group
 */
export const groupAdd = (id, group) => ({
  meta: {
    data: { id, group },
    errorMessage: `Error adding group to user. Please try again.`,
    method: 'patch',
    successMessage: `Group added to user.`,
    url: '/api/v1/users/addGroup',
  },
  type: DETAIL_USER_GROUP_ADD,
})

/**
 * Patch request to API to remove a group from a specific user.
 * @param {Number} id
 * @param {Number} group
 */
export const groupRemove = (id, group) => ({
  meta: {
    data: { id, group },
    errorMessage: `Error removing group from user. Please try again.`,
    method: 'patch',
    successMessage: `Group removed from user.`,
    url: '/api/v1/users/removeGroup',
  },
  type: DETAIL_USER_GROUP_REMOVE,
})

/**
 * Patch request to API to change a specific user's last name.
 * @param {Number} id
 * @param {Number} lastName
 */
export const lastNameChange = (id, lastName) => ({
  meta: {
    data: { id, lastName },
    errorMessage: `Error updating user information. Please try again.`,
    method: 'patch',
    successMessage: `Updated user information.`,
    url: '/api/v1/users/changeLastName',
  },
  type: DETAIL_USER_LAST_NAME_CHANGE,
})

/**
 * Patch request to API to remove a role from a specific user.
 * @param {Number} id
 */
export const passwordReset = id => ({
  payload: {
    confirmationMessage: `Are you sure you want reset the user's password?`,
  },
  meta: {
    data: { id },
    errorMessage: 'Error reseting user password. Please try again.',
    method: 'patch',
    successMessage: 'Password reseted.',
    url: `/api/v1/users/resetPassword`,
  },
  type: DETAIL_USER_PASSWORD_RESET,
})

/**
 * Get request to API to get a specific user.
 * @param {Number} id
 */
export const userGet = id => ({
  meta: { url: `/api/v1/users/${id}` },
  type: DETAIL_USER_GET,
})
